import FormLayout from 'components/v2/FormLayout'
import Heading from 'components/v2/Heading'
import { FilePreview, InputFile, MB } from 'components/v2/InputFile'
import { documentsMessages } from 'features/Partners/components/PartnerDocumentsFormCard/messages'
import { INewPartnerStep3 } from 'features/Partners/types'
import { useFormikContext } from 'formik'
import { ReactElement } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'
import { safeFormatMessage } from 'utils/intl'

const DocumentsGrid = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  gap: 16px;
`

const DocumentGridItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const PartnerDocumentsFormCard = (): ReactElement => {
  const intl = useIntl()
  const { values, setFieldValue } = useFormikContext<INewPartnerStep3>()

  const fileAcceptedFiles = {
    'application/pdf': [],
    'image/jpeg': [],
    'image/jpg': [],
    'image/png': []
  }
  const fileMaxSize = 16 * MB

  return (
    <FormLayout.Card small>
      <Heading.H4>
        <FormattedMessage id="partners.form.section.documents.title" defaultMessage="Documents" />
      </Heading.H4>
      <DocumentsGrid>
        {values.documents.map((document, index) => {
          const label = safeFormatMessage({ intl, messages: documentsMessages, key: document.category })

          return (
            <DocumentGridItem key={document.category}>
              <Heading.Label>{label}</Heading.Label>
              <InputFile
                placeholder={label}
                onChange={(file): void => {
                  if (file instanceof File) {
                    setFieldValue(`documents[${index}]`, {
                      id: '',
                      category: document.category,
                      file,
                      filename: file.name
                    })
                  }
                }}
                accept={fileAcceptedFiles}
                maxSize={fileMaxSize}
              />
              {values.documents[index].file && (
                <div>
                  <FilePreview
                    file={values.documents[index].file}
                    filename={values.documents[index].filename}
                    onRemoveFile={(): void => {
                      setFieldValue(`documents[${index}]`, {
                        id: '',
                        category: document.category,
                        file: '',
                        filename: ''
                      })
                    }}
                  />
                </div>
              )}
            </DocumentGridItem>
          )
        })}
      </DocumentsGrid>
    </FormLayout.Card>
  )
}
